import { takeLatest, put } from 'redux-saga/effects'
import {
  CHANGE_USER_ACCOUNT,
  LOGOUT,
} from 'portal-modules/auth/redux/modules/user'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'

// action types
const REQUEST_SCHEDULED_CHARGES = 'rp/ledger/REQUEST_SCHEDULED_CHARGES'
const RECEIVE_SCHEDULED_CHARGES = 'rp/ledger/RECEIVE_SCHEDULED_CHARGES'

// reducer
export default function scheduledCharges(state = {}, { type, payload }) {
  switch (type) {
    case RECEIVE_SCHEDULED_CHARGES:
      return { ...state, ...payload }
    case CHANGE_USER_ACCOUNT:
    case LOGOUT:
      return {}
    default:
      return state
  }
}

// action creators
export const addScheduledCharges = payload => ({
  type: REQUEST_SCHEDULED_CHARGES,
  payload,
})

// sagas
function* postAddScheduledCharges({ payload = {} }) {
  if (payload) {
    yield put({
      type: RECEIVE_SCHEDULED_CHARGES,
      payload: payload,
    })
  }
}

function* watchAddScheduledCharges() {
  yield takeLatest(
    REQUEST_SCHEDULED_CHARGES,
    createRequestSaga(postAddScheduledCharges, {
      key: 'payments',
      message: __('Looking for scheduled charges'),
    }),
  )
}

export const sagas = [watchAddScheduledCharges]
